import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type MaximizeIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

// No design-library glyph exists for maximize yet. Uses the Lucide 'maximize-2'
// glyph on its native 24x24 grid (stroke 1.5, round caps), matching
// FileTextIcon. Replace with the library asset when one lands.
export const MaximizeIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: MaximizeIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='Maximize'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 24 24'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15 3h6v6'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='M9 21H3v-6'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='m21 3-7 7'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='m3 21 7-7'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
    </svg>
  )
}
